export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: () => [...notificationKeys.lists()] as const,
  unreadList: () => [...notificationKeys.lists(), 'unread'] as const,
};

export const notificationSettingsKey = ['notification-settings'] as const;
